const Land: any = (
  style = {},
  fill = '#000',
  width = '100%',
  height = '100%',
  viewBox = '0 0 64 56',
) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M31.9997 50.2095C31.8507 50.2095 31.7017 50.1765 31.5637 50.1095L0.563749 35.1095C0.0667489 34.8685 -0.141251 34.2705 0.0987489 33.7735C0.339749 33.2775 0.935749 33.0705 1.43475 33.3085L31.9997 48.0985L62.5637 33.3095C63.0647 33.0715 63.6597 33.2785 63.8997 33.7745C64.1397 34.2715 63.9318 34.8695 63.4347 35.1105L32.4347 50.1105C32.2977 50.1765 32.1487 50.2095 31.9997 50.2095Z"
      fill={fill}
    />
    <path
      d="M31.9997 55.2094C31.8507 55.2094 31.7017 55.1764 31.5637 55.1094L0.563749 40.1094C0.0667489 39.8684 -0.141251 39.2704 0.0987489 38.7734C0.339749 38.2784 0.935749 38.0694 1.43475 38.3084L31.9997 53.0984L62.5637 38.3094C63.0647 38.0704 63.6597 38.2794 63.8997 38.7744C64.1397 39.2714 63.9318 39.8694 63.4347 40.1104L32.4347 55.1104C32.2977 55.1764 32.1487 55.2094 31.9997 55.2094Z"
      fill={fill}
    />
    <path
      d="M1 40.2095C0.447 40.2095 0 39.7625 0 39.2095V34.2095C0 33.6565 0.447 33.2095 1 33.2095C1.553 33.2095 2 33.6565 2 34.2095V39.2095C2 39.7625 1.553 40.2095 1 40.2095Z"
      fill={fill}
    />
    <path
      d="M63 40.2095C62.447 40.2095 62 39.7625 62 39.2095V34.2095C62 33.6565 62.447 33.2095 63 33.2095C63.553 33.2095 64 33.6565 64 34.2095V39.2095C64 39.7625 63.553 40.2095 63 40.2095Z"
      fill={fill}
    />
    <path
      d="M32 55.2095C31.447 55.2095 31 54.7625 31 54.2095V49.2095C31 48.6565 31.447 48.2095 32 48.2095C32.553 48.2095 33 48.6565 33 49.2095V54.2095C33 54.7625 32.553 55.2095 32 55.2095Z"
      fill={fill}
    />
    <path
      d="M18.499 36.2095C17.946 36.2095 17.499 35.7625 17.499 35.2095V13.6215C17.499 13.0685 17.946 12.6215 18.499 12.6215C19.052 12.6215 19.499 13.0685 19.499 13.6215V35.2095C19.499 35.7625 19.052 36.2095 18.499 36.2095Z"
      fill={fill}
    />
    <path
      d="M45.499 36.2095C44.946 36.2095 44.499 35.7625 44.499 35.2095V13.7655C44.499 13.2125 44.946 12.7655 45.499 12.7655C46.052 12.7655 46.499 13.2125 46.499 13.7655V35.2095C46.499 35.7625 46.052 36.2095 45.499 36.2095Z"
      fill={fill}
    />
    <path
      d="M14.5004 17.2094C14.1724 17.2094 13.8514 17.0484 13.6594 16.7524C13.3594 16.2884 13.4924 15.6704 13.9564 15.3694L30.9564 4.36944C31.4204 4.07044 32.0394 4.20244 32.3394 4.66644C32.6394 5.13044 32.5064 5.74844 32.0424 6.04944L15.0424 17.0494C14.8744 17.1574 14.6874 17.2094 14.5004 17.2094Z"
      fill={fill}
    />
    <path
      d="M49.498 17.2095C49.32 17.2095 49.141 17.1625 48.977 17.0635L30.977 6.06347C30.505 5.77547 30.357 5.16047 30.645 4.68847C30.932 4.21647 31.547 4.06847 32.02 4.35647L50.02 15.3565C50.492 15.6445 50.64 16.2595 50.352 16.7315C50.164 17.0395 49.835 17.2095 49.498 17.2095Z"
      fill={fill}
    />
    <path
      d="M14.5004 13.2094C14.1724 13.2094 13.8514 13.0484 13.6594 12.7524C13.3594 12.2884 13.4924 11.6704 13.9564 11.3694L30.9564 0.369443C31.4204 0.0704432 32.0394 0.202443 32.3394 0.666443C32.6394 1.13044 32.5064 1.74844 32.0424 2.04944L15.0424 13.0494C14.8744 13.1574 14.6874 13.2094 14.5004 13.2094Z"
      fill={fill}
    />
    <path
      d="M49.498 13.2095C49.32 13.2095 49.141 13.1625 48.977 13.0635L30.977 2.06347C30.505 1.77547 30.357 1.16047 30.645 0.688468C30.932 0.216468 31.547 0.0684675 32.02 0.356467L50.02 11.3565C50.492 11.6445 50.64 12.2595 50.352 12.7315C50.164 13.0395 49.835 13.2095 49.498 13.2095Z"
      fill={fill}
    />
    <path
      d="M47.499 36.2095H16.499C15.946 36.2095 15.499 35.7625 15.499 35.2095C15.499 34.6565 15.946 34.2095 16.499 34.2095H47.499C48.052 34.2095 48.499 34.6565 48.499 35.2095C48.499 35.7625 48.052 36.2095 47.499 36.2095Z"
      fill={fill}
    />
    <path
      d="M14.499 17.2095C13.946 17.2095 13.499 16.7625 13.499 16.2095V12.2095C13.499 11.6565 13.946 11.2095 14.499 11.2095C15.052 11.2095 15.499 11.6565 15.499 12.2095V16.2095C15.499 16.7625 15.052 17.2095 14.499 17.2095Z"
      fill={fill}
    />
    <path
      d="M49.499 17.2095C48.946 17.2095 48.499 16.7625 48.499 16.2095V12.2095C48.499 11.6565 48.946 11.2095 49.499 11.2095C50.052 11.2095 50.499 11.6565 50.499 12.2095V16.2095C50.499 16.7625 50.052 17.2095 49.499 17.2095Z"
      fill={fill}
    />
    <path
      d="M28.499 36.2105C27.946 36.2105 27.499 35.7635 27.499 35.2105V23.2095C27.499 22.6565 27.946 22.2095 28.499 22.2095C29.052 22.2095 29.499 22.6565 29.499 23.2095V35.2105C29.499 35.7635 29.052 36.2105 28.499 36.2105Z"
      fill={fill}
    />
    <path
      d="M35.499 24.2095H28.499C27.946 24.2095 27.499 23.7625 27.499 23.2095C27.499 22.6565 27.946 22.2095 28.499 22.2095H35.499C36.052 22.2095 36.499 22.6565 36.499 23.2095C36.499 23.7625 36.052 24.2095 35.499 24.2095Z"
      fill={fill}
    />
    <path
      d="M35.499 36.2105C34.946 36.2105 34.499 35.7635 34.499 35.2105V23.2095C34.499 22.6565 34.946 22.2095 35.499 22.2095C36.052 22.2095 36.499 22.6565 36.499 23.2095V35.2105C36.499 35.7635 36.052 36.2105 35.499 36.2105Z"
      fill={fill}
    />
    <path
      d="M31.499 20.2095C28.742 20.2095 26.499 17.9665 26.499 15.2095C26.499 12.4525 28.742 10.2095 31.499 10.2095C34.256 10.2095 36.499 12.4525 36.499 15.2095C36.499 17.9665 34.256 20.2095 31.499 20.2095ZM31.499 12.2095C29.845 12.2095 28.499 13.5555 28.499 15.2095C28.499 16.8635 29.845 18.2095 31.499 18.2095C33.153 18.2095 34.499 16.8635 34.499 15.2095C34.499 13.5555 33.153 12.2095 31.499 12.2095Z"
      fill={fill}
    />
    <path
      d="M31.499 20.2095C30.946 20.2095 30.499 19.7625 30.499 19.2095V11.2095C30.499 10.6565 30.946 10.2095 31.499 10.2095C32.052 10.2095 32.499 10.6565 32.499 11.2095V19.2095C32.499 19.7625 32.052 20.2095 31.499 20.2095Z"
      fill={fill}
    />
    <path
      d="M35.499 16.2095H27.499C26.946 16.2095 26.499 15.7625 26.499 15.2095C26.499 14.6565 26.946 14.2095 27.499 14.2095H35.499C36.052 14.2095 36.499 14.6565 36.499 15.2095C36.499 15.7625 36.052 16.2095 35.499 16.2095Z"
      fill={fill}
    />
    <path
      d="M30.5294 30.2095C29.9764 30.2095 29.5244 29.7625 29.5244 29.2095C29.5244 28.6565 29.9664 28.2095 30.5184 28.2095H30.5294C31.0814 28.2095 31.5294 28.6565 31.5294 29.2095C31.5294 29.7625 31.0814 30.2095 30.5294 30.2095Z"
      fill={fill}
    />
    <path
      d="M42.0294 47.8705C41.4764 47.8705 41.0244 47.4235 41.0244 46.8705C41.0244 46.3175 41.4664 45.8705 42.0184 45.8705H42.0294C42.5814 45.8705 43.0294 46.3175 43.0294 46.8705C43.0294 47.4235 42.5814 47.8705 42.0294 47.8705Z"
      fill={fill}
    />
    <path
      d="M57.0294 40.6124C56.4764 40.6124 56.0244 40.1654 56.0244 39.6124C56.0244 39.0594 56.4664 38.6124 57.0184 38.6124H57.0294C57.5814 38.6124 58.0294 39.0594 58.0294 39.6124C58.0294 40.1654 57.5814 40.6124 57.0294 40.6124Z"
      fill={fill}
    />
    <path
      d="M52.0294 43.0315C51.4764 43.0315 51.0244 42.5845 51.0244 42.0315C51.0244 41.4785 51.4664 41.0315 52.0184 41.0315H52.0294C52.5814 41.0315 53.0294 41.4785 53.0294 42.0315C53.0294 42.5845 52.5814 43.0315 52.0294 43.0315Z"
      fill={fill}
    />
    <path
      d="M47.0294 45.4514C46.4764 45.4514 46.0244 45.0044 46.0244 44.4514C46.0244 43.8984 46.4664 43.4514 47.0184 43.4514H47.0294C47.5814 43.4514 48.0294 43.8984 48.0294 44.4514C48.0294 45.0044 47.5814 45.4514 47.0294 45.4514Z"
      fill={fill}
    />
    <path
      d="M37.0294 50.2905C36.4764 50.2905 36.0244 49.8435 36.0244 49.2905C36.0244 48.7375 36.4664 48.2905 37.0184 48.2905H37.0294C37.5814 48.2905 38.0294 48.7375 38.0294 49.2905C38.0294 49.8435 37.5814 50.2905 37.0294 50.2905Z"
      fill={fill}
    />
    <path
      d="M36 39.2095H28C27.447 39.2095 27 38.7625 27 38.2095C27 37.6565 27.447 37.2095 28 37.2095H36C36.553 37.2095 37 37.6565 37 38.2095C37 38.7625 36.553 39.2095 36 39.2095Z"
      fill={fill}
    />
    <path
      d="M22.0294 47.8705C21.4764 47.8705 21.0244 47.4235 21.0244 46.8705C21.0244 46.3175 21.4664 45.8705 22.0184 45.8705H22.0294C22.5814 45.8705 23.0294 46.3175 23.0294 46.8705C23.0294 47.4235 22.5814 47.8705 22.0294 47.8705Z"
      fill={fill}
    />
    <path
      d="M7.02941 40.6124C6.47641 40.6124 6.02441 40.1654 6.02441 39.6124C6.02441 39.0594 6.46641 38.6124 7.01841 38.6124H7.02941C7.58141 38.6124 8.02941 39.0594 8.02941 39.6124C8.02941 40.1654 7.58141 40.6124 7.02941 40.6124Z"
      fill={fill}
    />
    <path
      d="M12.0294 43.0315C11.4764 43.0315 11.0244 42.5845 11.0244 42.0315C11.0244 41.4785 11.4664 41.0315 12.0184 41.0315H12.0294C12.5814 41.0315 13.0294 41.4785 13.0294 42.0315C13.0294 42.5845 12.5814 43.0315 12.0294 43.0315Z"
      fill={fill}
    />
    <path
      d="M17.0294 45.4514C16.4764 45.4514 16.0244 45.0044 16.0244 44.4514C16.0244 43.8984 16.4664 43.4514 17.0184 43.4514H17.0294C17.5814 43.4514 18.0294 43.8984 18.0294 44.4514C18.0294 45.0044 17.5814 45.4514 17.0294 45.4514Z"
      fill={fill}
    />
    <path
      d="M27.0294 50.2905C26.4764 50.2905 26.0244 49.8435 26.0244 49.2905C26.0244 48.7375 26.4664 48.2905 27.0184 48.2905H27.0294C27.5814 48.2905 28.0294 48.7375 28.0294 49.2905C28.0294 49.8435 27.5814 50.2905 27.0294 50.2905Z"
      fill={fill}
    />
    <path
      d="M1.00073 35.2094C0.628726 35.2094 0.271725 35.0014 0.0997254 34.6454C-0.140275 34.1484 0.0677254 33.5504 0.564725 33.3094L18.0647 24.8424C18.5657 24.6044 19.1607 24.8124 19.4007 25.3074C19.6407 25.8044 19.4327 26.4024 18.9357 26.6434L1.43573 35.1094C1.29473 35.1774 1.14573 35.2094 1.00073 35.2094Z"
      fill={fill}
    />
    <path
      d="M62.9988 35.2094C62.8528 35.2094 62.7048 35.1774 62.5637 35.1094L45.0637 26.6424C44.5667 26.4014 44.3587 25.8034 44.5987 25.3064C44.8397 24.8114 45.4358 24.6034 45.9348 24.8414L63.4348 33.3084C63.9318 33.5494 64.1398 34.1474 63.8998 34.6444C63.7278 35.0014 63.3708 35.2094 62.9988 35.2094Z"
      fill={fill}
    />
  </svg>
)

export default Land
